import { render, staticRenderFns } from "./ClaimInformation.vue?vue&type=template&id=b1503e48&scoped=true&"
import script from "./ClaimInformation.vue?vue&type=script&lang=ts&"
export * from "./ClaimInformation.vue?vue&type=script&lang=ts&"
import style0 from "./ClaimInformation.vue?vue&type=style&index=0&id=b1503e48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1503e48",
  null
  
)

export default component.exports